import { IconButton, Typography } from '@mui/material';

import Box from '@mui/material/Box';
import CancelIcon from '@mui/icons-material/Cancel';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    title: {
        color: theme.palette.secondary.muted2,
        textTransform: "uppercase", 
    }
}));

export default function ContentDialog({ children, state, setState, title, subTitle, handleClose = ()=>{}, scroll = "body", ...props }) {
    const classes = useStyles();

    const _handleClose = (e) => {
        const newState = { 
            ...state,
            open: false,
        };
        setState(newState);
        handleClose.call(this, e, newState);
    };

    return (
        <Dialog
            open={state.open}
            onClose={_handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            scroll={scroll}
            maxWidth="md"
            {...props}

            PaperProps={{
                style: {
                    backgroundColor: "#111",
                    border: '1px solid rgba(255,255,255,0.1)',
                    borderRadius: '0px',
                },
            }}
        >
            <DialogTitle style={{ cursor: 'move', paddingBottom: 0 }} id="draggable-dialog-title">
                <Box display="flex" style={{ alignItems: "center" }}>
                    <Box flexGrow={1}>
                        <Typography variant="overline" component="h2" className={classes.title}>{title}</Typography>
                    </Box>
                    <Box>
                        <IconButton
                            onTouchEnd={_handleClose}
                            onClick={_handleClose}
                            aria-label="close"
                            style={{cursor: "pointer", display: "flex", alignItems: "center", padding: ".5rem", margin: "-.5rem"}}
                            size="large">
                            <CancelIcon />
                        </IconButton>
                    </Box>
                </Box>
            </DialogTitle>
            {
                !subTitle ? "" : (
                    <DialogTitle style={{paddingTop: ".2rem", paddingBottom: 0}}>
                        <Typography variant="h6" component="h3">{subTitle}</Typography>
                    </DialogTitle>
                )
            }
                
            {React.cloneElement(children)}
        </Dialog>
    );
}

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}
